import { render, staticRenderFns } from "./mod-01.vue?vue&type=template&id=74ac2097&scoped=true&"
import script from "./mod-01.vue?vue&type=script&lang=js&"
export * from "./mod-01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac2097",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
